import { type ComponentProps } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { StyleSheet, View } from 'react-native';
import { Container, IconLink, theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const ProductDetailsBackButton = (props: Props) => {
  const { formatMessage } = useIntl();

  return (
    <View style={styles.container} pointerEvents="box-none">
      <Container pointerEvents="box-none">
        <IconLink
          name="IconArrowLeft"
          palette="dark-kale"
          iconSize={24}
          width={40}
          height={40}
          accessibilityLabel={formatMessage(messages.back)}
          {...props}
        />
      </Container>
    </View>
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  back: {
    defaultMessage: 'Go back',
    description: 'Product Details | Back button label',
  },
});

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    top: theme.spacing['5'],
    left: 0,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = Omit<
  ComponentProps<typeof IconLink>,
  'name' | 'accessibilityLabel'
>;
